import { MarkdownEditor, ViewMode } from '@efdigital/ll-addon-codemirror';
import { PageWidgetType } from '@efdigital/ll-addon-data';
import { DataTypeContent } from '@efdigital/ll-addon-data/data-types';
import type {
  PageWidgetMarkdown,
  PageWidgetMarkdownLike,
} from '@efdigital/ll-addon-data/types/content/objects/page-widget-markdown';
import Component from '@glimmer/component';

import { SidebarAll } from '../../../lib/markdown-toolbar.ts';
import type {
  PageWidgetComponentSignature,
  WidgetEditor,
} from '../page-widget-signature';

export class PageWidgetMarkdownComponent extends Component<PageWidgetComponentSignature> {
  get widget() {
    return this.args.widget as PageWidgetMarkdown;
  }

  setMarkdown = (markdown: string) => {
    this.widget.markdown = markdown;
  };

  <template>
    <div class="card-body p-0">
      <MarkdownEditor
        @markdown={{this.widget.markdown}}
        @toolbar={{SidebarAll}}
        @mode={{ViewMode.EditorOnly}}
        @onUpdate={{this.setMarkdown}}
      >
        <:preview as |markdown|>
          <pre>{{markdown}}</pre>
        </:preview>
      </MarkdownEditor>
    </div>
  </template>
}

const DEFAULT_WIDGET_MARKDOWN: Omit<PageWidgetMarkdownLike, 'wid'> = {
  widgetType: PageWidgetType.Markdown,
  title: 'Markdown',
  css: '',
  markdown: '',
};

export const MarkdownWidgetEditor: WidgetEditor = {
  icon: 'ph:text-aa-bold',
  label: 'Markdown',
  component: PageWidgetMarkdownComponent,
  dataType: DataTypeContent.PageWidgetMarkdown,
  widgetData: DEFAULT_WIDGET_MARKDOWN,
};
